const userTaskServiceName = "/ReminderTask"

export function reminderTaskService(http) {
    return {
        getUserReminderTasks: (userId) => {
            var params = {
                UserId: userId
            }
            return http.post(userTaskServiceName + "/GetPersonnelReminderTasks", params);
        },
        finishSelectedReminderTask: (taskId) => {
            var params = {
                TaskId: taskId
            }
            return http.post(userTaskServiceName + "/FinishSelectedReminderTask", params);
        },
        removeSelectedReminderTask: (taskId) => {
            var params = {
                TaskId: taskId
            }
            return http.post(userTaskServiceName + "/RemoveSelectedReminderTask", params);
        },
        AddNewReminderTask : (userProfileId, taskDescription) => {
            var params = {
                UserProfileId: userProfileId,
                Description: taskDescription
            }
            return http.post(userTaskServiceName + "/AddNewReminderTask", params);
        }
    }
}

